import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCasingOD } from "../../../services/calculations/calculation-input/tubing.service";
import { transformObjectToKeyValueArray } from "../../../utilities/commonUtilities";

interface TubingState {
    loading: boolean;
    error: string | undefined;
    tab1Input: any;
}

export const initialState: TubingState = {
    loading: false,
    error: "",
    tab1Input: null,
};

export const gettingCasingOD = createAsyncThunk(
    "calculation-tubing/gettingCasingOD",
    async () => {
        try {
            const response = await getCasingOD();
            return response;
        } catch (error) {
            throw Error("Error fetching casing od list: " + error);
        }
    }
);

const TubingSlice = createSlice({
    name: "tubing",
    initialState,
    reducers: {
        resetTubingTab: () => ({
            ...initialState
        }),
        setTubingDetails: (state, action) => {
            state.tab1Input = action?.payload;
        },
        setCasingODList: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    casingODList: Object?.keys(action?.payload)?.length > 0 ? transformObjectToKeyValueArray(action?.payload) : [],
                };
            }
        },
        setCasingOD(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    casingOD: action.payload,
                };
            }
        },
        setCasingWeight(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    casingWeight: action.payload,
                };
            }
        },
        setCasingID(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    casingID: action.payload,
                };
            }
        },
        setCasingDriftID(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    casingDriftID: action.payload,
                };
            }
        },
        setLinerOD(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    linerOD: action.payload,
                };
            }
        },
        setLinerWeight(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    linerWeight: action.payload,
                };
            }
        },
        setLinerID(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    linerID: action.payload,
                };
            }
        },
        setLinerTop(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    linerTop: action.payload,
                };
            }
        },
        setTubingOD(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    tubingOD: action.payload,
                };
            }
        },
        setTubingID(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    tubingID: action.payload,
                };
            }
        },
        setTubingTypeUpset(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    tubingTypeUpset: action.payload,
                };
            }
        },
        setTubingWeight(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    tubingWeight: action.payload,
                };
            }
        },
        setTubingType(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    tubingType: action.payload,
                };
            }
        },
        setTubingTypeList(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    tubingTypeList: Object?.keys(action.payload)?.length > 0 ? Object.keys(action?.payload).map((key) => ({
                        value: action?.payload[key],
                        label: key,
                    })) : [],
                };
            }
        },
        setCasingWeightList(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    casingWeightList: Object?.keys(action?.payload)?.length > 0 ? transformObjectToKeyValueArray(action?.payload) : [],
                };
            }
        },
        setLinerODList(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    linerODList: Object?.keys(action?.payload)?.length > 0 ? transformObjectToKeyValueArray(action?.payload) : [],
                };
            }
        },
        setLinerWeightList(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    linerWeightList: Object?.keys(action?.payload)?.length > 0 ? transformObjectToKeyValueArray(action?.payload) : [],
                };
            }
        },
        setWellTrajectory(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    wellTrajectory: action.payload,
                };
            }
        },
        setWellTrajectoryList(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    wellTrajectoryList: Object?.keys(action.payload)?.length > 0 ? Object.keys(action?.payload).map((key) => ({
                        value: action?.payload[key],
                        label: key,
                    })) : [],
                };
            }
        },
        setTubingODList(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    tubingODList: Object?.keys(action?.payload)?.length > 0 ? transformObjectToKeyValueArray(action?.payload) : [],
                };
            }
        },
        setTubingTypeUpsetList(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    tubingTypeUpsetList: Object?.keys(action.payload)?.length > 0 ? Object.keys(action?.payload).map((key) => ({
                        value: action?.payload[key],
                        label: key,
                    })) : [],
                };
            }
        },
        setTubingWeightList(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    tubingWeightList: Object?.keys(action?.payload)?.length > 0 ? transformObjectToKeyValueArray(action?.payload) : [],
                };
            }
        },
        setHiddenDesrdStg: (state, action) => {
            if (state?.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenDesrdStg: action?.payload,
                }
            };
        },
        setHiddenDesrdStg2: (state, action) => {
            if (state?.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenDesrdStg2: action?.payload,
                }
            }
        },
        setHiddenDesrdStg3: (state, action) => {
            if (state?.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenDesrdStg3: action?.payload,
                }
            };
        },
        setHiddenChargePumpSelected: (state, action) => {
            if (state?.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenChPmpSelcd: action?.payload,
                }
            };
        },
        setHiddenChargePumpSelected2: (state, action) => {
            if (state?.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenChPmp2Selcd: action?.payload,
                }
            };
        },
        setHiddenChargePumpSelected3: (state, action) => {
            if (state?.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenChPmp3Selcd: action?.payload,
                }
            };
        },
        setHiddenGasNatrAutoEff(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    hiddenGasNatrEffAuto: action?.payload
                };
            }
        },
        setHiddenGasAutoEff(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    hiddenGasAutoEff: action?.payload
                };
            }
        },
        setUnit(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    unitSys: action?.payload
                };
            }
        },
        setCatalogType(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    catalogType: action?.payload
                };
            }
        },
        setCatalogType2(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    catalogType: action?.payload
                };
            }
        },
        setChargePumpShowAll(state, action) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    chargePumpShowAll: action?.payload
                };
            }
        },
        setChargePumpShowAll2: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    chargePumpShowAll: action?.payload
                };
            }
        },
        setHiddenSep1Eff: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    hiddenSep1Eff: action?.payload
                };
            }
        },
        setHiddenSep2Eff: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    hiddenSep2Eff: action?.payload
                };
            }
        },
        setHiddenSep3Eff: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    hiddenSep3Eff: action?.payload
                };
            }
        },
        setHiddenSep4Eff: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    hiddenSep4Eff: action?.payload
                };
            }
        },
        clearCasingOD(state) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    casingOD: "",
                    casingWeight: "",
                    casingWeightList: [],
                    casingID: "",
                    casingDriftID: "",
                    linerOD: "",
                    linerODList: [],
                    linerWeight: "",
                    linerWeightList: [],
                    linerID: "",
                };
            }
        },
        clearCasingWeight(state) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    casingWeight: "",
                    casingID: "",
                    casingDriftID: "",
                };
            }
        },
        clearLiner(state) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    linerODList: [],
                    linerWeight: "",
                    linerWeightList: [],
                    linerID: "",
                    linerOD: "",
                };
            }
        },
        clearTubing(state) {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state?.tab1Input,
                    tubingOD: "",
                    tubingID: "",
                    tubingWeight: "",
                    tubingWeightList: [],
                };
            }
        },
        setHiddenPumpId: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenPumpID: action?.payload,
                }
            };
        },
        setHiddenPumpShowAll: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnPmpShowAll: action?.payload,
                }
            };
        },
        setHiddenHousingType: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdn_Pump_HousingType: action?.payload,
                }
            };
        },
        setHiddenShaftType: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdn_Pump_ShaftType: action?.payload,
                }
            };
        },
        setHiddenProtectorBearingType: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnProtector_BearingType: action?.payload,
                }
            };
        },
        setHiddenProtector1: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnProtector_Protector1: action?.payload,
                }
            };
        },
        setHiddenProtector1HP: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnProtector_Protector1HP: action?.payload,
                }
            };
        },
        setHiddenProtector2: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnProtector_Protector2: action?.payload,
                }
            };
        },
        setHiddenProtector2HP: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnProtector_Protector2HP: action?.payload,
                }
            };
        },
        setHiddenProtectorShaftType: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnProtector_ShaftType: action?.payload,
                }
            };
        },
        setHiddenProtectorOilType: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnProtector_OilType: action?.payload,
                }
            };
        },
        setHiddenProtectorMotorHP: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenMotrHP: action?.payload,
                }
            };
        },
        setHiddenMotor60HP: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenMotr60HP: action?.payload,
                }
            };
        },
        setHiddenMotorId: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenMotrID: action?.payload,
                }
            };
        },
        setHiddenMotorSensor: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnMotr_Sensr: action?.payload,
                }
            };
        },
        setHiddenMotorShowAll: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnMotrShowAll: action?.payload,
                }
            };
        },
        setHiddenMotorAuto: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnMotrAutoHP: action?.payload,
                }
            };
        },
        setHiddenMotorSeries: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenMotrSers: action?.payload,
                }
            };
        },
        setHiddenMotorSharedOD: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenMotrShrdOD: action?.payload,
                }
            };
        },
        setHiddenMotorShrdWt: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenMotrShrdWght: action?.payload,
                }
            };
        },
        setHiddenMotorShrdRequired: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenWthrMotrShrd: action?.payload,
                }
            };
        },
        setHiddenMotorShrdRequiredInitialize: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenWthrMotrShrd: action?.payload,
                }
            };
        },
        setHiddenCableDriftId: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnCable_IsDriftID: action?.payload,
                }
            };
        },
        setHiddenCablePumpLockPlate: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnCable_PumpLockPlate: action?.payload,
                }
            };
        },
        setHiddenCableSealLockPlate: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnCable_SealLockPlate: action?.payload,
                }
            };
        },
        setHiddenCableMotorLockPlate: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnCable_MotorLockPlate: action?.payload,
                }
            };
        },
        setHiddenCableEstCabLng: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnCable_EstCabLng: action?.payload,
                }
            };
        },
        setHiddenCableSurfaceCabl: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnCable_SurfCabl: action?.payload,
                }
            };
        },
        setHiddenCableLockPlate: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnCable_LockPlate: action?.payload,
                }
            };
        },
        setHiddenCableMotorLead: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnCable_MotorLead: action?.payload,
                }
            };
        },
        setHiddenCableType: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnCable_CableType: action?.payload,
                }
            };
        },
        setHiddenSurfacePowerFactor: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnSurface_PwrFactr: action?.payload,
                }
            };
        },
        setHiddenSurfaceEfficiency: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnSurface_Efficiency: action?.payload,
                }
            };
        },
        setHiddenSurfaceCstPrHr: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnSurface_CstPrHr: action?.payload,
                }
            };
        },
        setHiddenSurfaceSupplyVoltage: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnSurface_SuplVlt: action?.payload,
                }
            };
        },
        setHiddenSurfaceControlType: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hdnCntrlTyp: action?.payload,
                }
            };
        },
        setHiddenSurfaceControlLr: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    HdnSurf_Cntrlr: action?.payload,
                    hiddenSurfVSD: action?.payload,
                }
            };
        },
        setHiddenSurfaceSwitchBoard: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenSwtchBrd: action?.payload,
                }
            }
        },
        setDummy: (state) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    dummy: true,
                }
            }
        },
        setHiddenSurfaceVSD: (state, action) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenSurfVSD: action?.payload,
                    HdnSurf_Cntrlr: action?.payload,
                }
            }
        },
        resetHiddenMotorID: (state) => {
            if (state.tab1Input) {
                state.tab1Input = {
                    ...state.tab1Input,
                    hiddenMotrID: '',
                    hdnMotr_Sensr: -1
                }
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(gettingCasingOD.pending, (state) => {
            state.loading = true;
            state.error = "";
        });
        builder.addCase(gettingCasingOD.fulfilled, (state, action) => {
            if (action?.payload.length > 0) {
                const valueArray = action.payload.map(
                    (item: { size: string; name: string }) => ({
                        value: item.size,
                        label: item.name,
                    })
                );
                valueArray.unshift({ value: "", label: "Select" });
                state.tab1Input = {
                    ...state?.tab1Input,
                    casingODList: valueArray,
                };
            }
            state.loading = false;
            state.error = "";
        });
        builder.addCase(gettingCasingOD.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    },
});

export const {
    resetTubingTab,
    setTubingDetails,
    setCasingOD,
    setCasingWeight,
    setCasingID,
    setCasingDriftID,
    setLinerOD,
    setLinerWeight,
    setLinerID,
    setLinerTop,
    setTubingOD,
    setTubingID,
    setTubingTypeUpset,
    setTubingWeight,
    setTubingType,
    setCasingWeightList,
    setLinerODList,
    setLinerWeightList,
    setWellTrajectory,
    setWellTrajectoryList,
    setTubingODList,
    setTubingTypeUpsetList,
    setTubingWeightList,
    clearCasingOD,
    clearCasingWeight,
    clearLiner,
    clearTubing,
    setTubingTypeList,
    setHiddenDesrdStg,
    setHiddenDesrdStg2,
    setHiddenDesrdStg3,
    setHiddenChargePumpSelected,
    setHiddenChargePumpSelected2,
    setHiddenChargePumpSelected3,
    setHiddenGasNatrAutoEff,
    setHiddenGasAutoEff,
    setUnit,
    setCatalogType,
    setCatalogType2,
    setChargePumpShowAll,
    setChargePumpShowAll2,
    setHiddenSep1Eff,
    setHiddenSep2Eff,
    setHiddenSep3Eff,
    setHiddenSep4Eff,
    setCasingODList,
    setHiddenPumpId,
    setHiddenPumpShowAll,
    setHiddenCableDriftId,
    setHiddenCableEstCabLng,
    setHiddenCableLockPlate,
    setHiddenCableMotorLead,
    setHiddenCableMotorLockPlate,
    setHiddenCablePumpLockPlate,
    setHiddenCableSealLockPlate,
    setHiddenCableSurfaceCabl,
    setHiddenCableType,
    setHiddenHousingType,
    setHiddenMotor60HP,
    setHiddenMotorAuto,
    setHiddenMotorId,
    setHiddenMotorSensor,
    setHiddenMotorShowAll,
    setHiddenMotorSeries,
    setHiddenMotorSharedOD,
    setHiddenMotorShrdRequired,
    setHiddenMotorShrdRequiredInitialize,
    setHiddenMotorShrdWt,
    setHiddenProtector1,
    setHiddenProtector1HP,
    setHiddenProtector2,
    setHiddenProtector2HP,
    setHiddenProtectorBearingType,
    setHiddenProtectorMotorHP,
    setHiddenProtectorOilType,
    setHiddenProtectorShaftType,
    setHiddenShaftType,
    setHiddenSurfaceControlLr,
    setHiddenSurfaceControlType,
    setHiddenSurfaceCstPrHr,
    setHiddenSurfaceEfficiency,
    setHiddenSurfacePowerFactor,
    setHiddenSurfaceSupplyVoltage,
    setHiddenSurfaceSwitchBoard,
    setDummy,
    setHiddenSurfaceVSD,
    resetHiddenMotorID,
} = TubingSlice.actions;

export default TubingSlice.reducer;
